import React from 'react';
import { useState, useContext } from 'react';
import { MazeResultContext } from '../customCursor/context/MazeResult';
import Input from '../styledComponents/Input';
import axios from 'axios';

const url = process.env.REACT_APP_URL_LOCAL;

const Maze3 = () => {
	const [inputValue, setInputValue] = useState('');
	const [resetInput, setResetInput] = useState(false);
	const {setMazeThreeResult} = useContext(MazeResultContext);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (inputValue === ""){
			return;
		}
		try {
			const body = { inputValue };
			const response = await axios.post(`${url}/maze-three`, body);
			if (response.data.success) {
				if (process.env.REACT_APP_MAZE_THREE === response.data.answer) {
					setMazeThreeResult(process.env.REACT_APP_MAZE_THREE);
				} else {
					setMazeThreeResult('');
					
				}
			} else {
				setMazeThreeResult('');
				setResetInput(true);
			}
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<>
			<div className="maze-3-container">
				<p>
				01001001 01101110 00100000 01101101  01111001 00100000 01101011 01101001 01101110 01100111 01100100 01101111 01101101 00101100 00100000 01110100 01101000 01100101 00100000 01110000 01100101 01101111 01110000 01101100 01100101 00100000 01110111 01100101 01100001 01110010 00100000 01110100 01101000 01100101 00100000 01100011 01110010 01101111 01110111 01101110 00101110
				</p>
				<form onSubmit={handleSubmit}>
					<div className='input-maze-3'>
						<Input
							inputValue={setInputValue}
							resetInput={resetInput}
							setResetInput={setResetInput}
						/>
					</div>
				</form>
			</div>
		</>
	);
};

export default Maze3;
